module.exports = __webpack_public_path__ + "a12b2da7d85f254a6c3a5f05c68d7bca.png";